import { Error } from "@progress/kendo-react-labels";
import { useState } from "react";
import Button from "../../components/button";
import Headline6 from "../../components/headings/Headline6";
import Modal from "../../components/modal";
import { FormInput } from "../../wrappers/formInput";

const TextArea = (props: any) => {
  const [remarks, setRemarks] = useState<string>();
  const [error, setError] = useState<string>('')

  const Submit = () => {
    if (props.mandatory && !remarks) {
      setError('Provide a reason')
    }
    else {
      props.onSubmit(remarks);
      props.onClose();
    }
   
  };

  const addRemarks = (e: any) => {
    setRemarks(e.target.value);
  };

  return (
    <Modal title="Availability" size="xsmall" onClose={props.onClose}>
      <Headline6>{props && props.confirmation}</Headline6> 
      <div className="form-group">
        <FormInput
          name="textArea"
          onChange={(e: any) => addRemarks(e)}
          placeholder={props.placeholder}
        />
      </div>
      <Error>{error}</Error>
      <div className="popupAction">
        <Button variant="secondary" onClick={props.onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={Submit}>
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default TextArea;
